import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Client, MeterAvailabilityDataIn } from '../../../../api/api-reference';
import { OnlineHoursComponent } from './online-hours/online-hours.component';

@Component({
  selector: 'app-connectivity',
  standalone: true,
  imports: [CommonModule, TranslateModule, OnlineHoursComponent],
  templateUrl: './connectivity.component.html',
  styleUrl: './connectivity.component.scss',
})
export class ConnectivityComponent {
  @Input() meterId = '';

  onlinePercentage = 0;
  offlinePercentage = 0;
  onlineMinutes = 0;
  offlineMinutes = 0;
  lastSeen?: Date;

  constructor(private client: Client, private toastr: ToastrService) {}

  onRangeWindowChange(dataIn: MeterAvailabilityDataIn): void {

    const infoDataIn = new MeterAvailabilityDataIn({
      meterId: dataIn.meterId,
      startTime: dataIn.startTime,
      endTime: dataIn.endTime,
    });

    this.client.getMeterAvailabilityForIntervalInfo(infoDataIn).subscribe({
      next: (info) => {
        this.onlinePercentage = info.onlinePercentage;
        this.offlinePercentage = info.offlinePercentage;
        this.onlineMinutes = info.onlineMinutes;
        this.offlineMinutes = info.offlineMinutes;
        this.lastSeen = info.lastSeen;
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }

  get onlineDurationLabel(): string {
    return this.formatDuration(this.onlineMinutes);
  }

  get offlineDurationLabel(): string {
    return this.formatDuration(this.offlineMinutes);
  }

  private formatDuration(totalMinutes: number): string {
    const totalHours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const minutesPart = minutes === 0 ? '' : ` ${minutes}min`;
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;

    if (days === 0) return totalHours === 0 ? (minutes === 0 ? '0h' : `${minutes}min`) : `${totalHours}h${minutesPart}`;
    if (hours === 0) return (days === 1 ? `${totalHours}h` : `${days}d`) + minutesPart;
    return `${days}d ${hours}h${minutesPart}`;
  }
}
